import React from 'react';
import { GALLERY, IMAGES } from '../mock';

export default function Ambiente() {
  const [gastraum, grill, detail] = GALLERY;
  return (
    <section id="ambiente" className="relative py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="reveal max-w-3xl">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-12 bg-[rgba(224,180,159,0.6)]" />
            <span className="eyebrow">02 — Ambiente</span>
          </div>
          <h2 className="font-serif-display font-medium text-[#f2ebe3] text-4xl md:text-6xl leading-[1.05]">
            Ein Raum, der verweilen lässt.
          </h2>
          <p className="mt-6 text-[#c3b7aa] text-lg font-light leading-relaxed">
            Naturstein, warmes Holz, weiche Polster und mediterrane Details – jedes Eck des Alfa erzählt von griechischer Lebensart.
          </p>
        </div>

        {/* Gallery grid */}
        <div className="reveal mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {/* Big left image */}
          <div className="img-zoom relative rounded-2xl overflow-hidden h-[420px] md:h-[640px]">
            <img src={gastraum.img} alt={gastraum.caption} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            <span className="absolute bottom-6 left-6 eyebrow text-[#f2ebe3]">{gastraum.caption}</span>
          </div>

          {/* Right column: two stacked */}
          <div className="grid grid-rows-2 gap-5 h-[420px] md:h-[640px]">
            <div className="img-zoom relative rounded-2xl overflow-hidden">
              <img src={grill.img} alt={grill.caption} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <span className="absolute bottom-6 left-6 eyebrow text-[#f2ebe3]">{grill.caption}</span>
            </div>
            <div className="img-zoom relative rounded-2xl overflow-hidden">
              <img src={detail.img} alt={detail.caption} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <span className="absolute bottom-6 left-6 eyebrow text-[#f2ebe3]">{detail.caption}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Full-width quote band */}
      <div className="reveal relative mt-20 h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden">
        <img src={IMAGES.quote} alt="Stimmungsvolles Ambiente" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#100d0b]/70" />
        <blockquote className="relative z-10 text-center px-6 max-w-4xl">
          <p className="font-serif-display italic text-[#f6f0e9] text-4xl md:text-6xl lg:text-7xl leading-[1.1]">
            „Man fühlt sich wie im Urlaub<br className="hidden md:block" /> am Mittelmeer.“
          </p>
        </blockquote>
      </div>
    </section>
  );
}
